// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21mGy","content":"styles_content__dyUe4"};